// extracted by mini-css-extract-plugin
export default {"channelsContainer":"Channels_channelsContainer__CeAL2","header":"Channels_header__w6YxY"};